// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__20iqB","title":"ClientInsurance_title__Zwf0t","itemText":"ClientInsurance_itemText__3RY24"};